module.exports = __webpack_public_path__ + "img/jifenhuodong.b197b14c.png";